// This file must be in shared-ui instead of rst-ui so that the LoseAccessModal can access the configs
import { LOCALE } from '@dashboard/shared-ui/utils/rst-upsell-config';
export const AllDevicesImageConfig = {
  [LOCALE.AU]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_AU@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_AU@2x.png'
    },
    height: 673,
    width: 1680
  },
  [LOCALE.GB]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_GB@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_GB@2x.png'
    },
    height: 673,
    width: 1680
  },
  [LOCALE.US]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_US@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_US@2x.png'
    },
    height: 357,
    width: 978
  },
  [LOCALE.CA]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_CA@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_CA@2x.png'
    },
    height: 387,
    width: 874
  },
  [LOCALE.ca_ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_ca_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_ca_ES@2x.png'
    },
    height: 351,
    width: 818
  },
  [LOCALE.IE]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_IE@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_IE@2x.png'
    },
    height: 320,
    width: 600
  },
  [LOCALE.FR]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_FR@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_FR@2x.png'
    },
    height: 327,
    width: 680
  },
  [LOCALE.ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_ES@2x.png'
    },
    height: 238,
    width: 600
  },
  [LOCALE.JP]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_JP@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_JP@2x.png'
    },
    height: 209,
    width: 600
  }
};
export const AllDevicesMobileImageConfig = {
  // to do
  [LOCALE.AU]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_AU@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_AU@2x.png'
    },
    height: 143,
    width: 341
  },
  [LOCALE.GB]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_GB@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_GB@2x.png'
    },
    height: 143,
    width: 341
  },
  [LOCALE.US]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_US@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_US@2x.png'
    },
    height: 125,
    width: 340
  },
  [LOCALE.CA]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_CA@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_CA@2x.png'
    },
    height: 320,
    width: 900
  },
  [LOCALE.ca_ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_ca_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_ca_ES@2x.png'
    },
    height: 176,
    width: 409
  },
  [LOCALE.FR]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_FR@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_FR@2x.png'
    },
    height: 164,
    width: 341
  },
  [LOCALE.ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_ES@2x.png'
    },
    height: 176,
    width: 409
  },
  [LOCALE.IE]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_IE@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_IE@2x.png'
    },
    height: 169,
    width: 402
  }
};
export const AllDevicesImagePlusConfig = {
  [LOCALE.AU]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_AU@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_AU@2x.png'
    },
    height: 673,
    width: 1680
  },
  [LOCALE.GB]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_GB@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_GB@2x.png'
    },
    height: 673,
    width: 1680
  },
  [LOCALE.US]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_US@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_US@2x.png'
    },
    height: 357,
    width: 978
  },
  [LOCALE.CA]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_CA@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_CA@2x.png'
    },
    height: 387,
    width: 874
  },
  [LOCALE.ca_ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_ca_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_ca_ES@2x.png'
    },
    height: 327,
    width: 818
  },
  [LOCALE.IE]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_IE@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_IE@2x.png'
    },
    height: 320,
    width: 600
  },
  [LOCALE.FR]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_FR@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_FR@2x.png'
    },
    height: 327,
    width: 818
  },
  [LOCALE.ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_PLUS_ES@2x.png'
    },
    height: 327,
    width: 818
  }
};
export const AllDevicesMobileImagePlusConfig = {
  [LOCALE.AU]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_AU@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_AU@2x.png'
    },
    height: 143,
    width: 341
  },
  [LOCALE.GB]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_GB@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_GB@2x.png'
    },
    height: 143,
    width: 341
  },
  [LOCALE.US]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_US@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_US@2x.png'
    },
    height: 125,
    width: 340
  },
  [LOCALE.CA]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_CA@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_CA@2x.png'
    },
    height: 320,
    width: 900
  },
  [LOCALE.ca_ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_ca_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_ca_ES@2x.png'
    },
    height: 164,
    width: 409
  },
  [LOCALE.FR]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_FR@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_FR@2x.png'
    },
    height: 164,
    width: 410
  },
  [LOCALE.ES]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_ES@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_ES@2x.png'
    },
    height: 164,
    width: 409
  },
  [LOCALE.IE]: {
    src: {
      '1x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_IE@1x.png',
      '2x': '/@dashboard/shared-ui/images/rst/hardware-montage_MOBILE_PLUS_IE@2x.png'
    },
    height: 162,
    width: 406
  }
};
export const RstMobileForDashboardImageConfig = {
  '1x': '/@dashboard/shared-ui/images/rst/us-hardware-lockup@1x.png',
  '2x': '/@dashboard/shared-ui/images/rst/us-hardware-lockup@2x.png'
};